import { render } from "./PaginationUserEnrolComponent.vue?vue&type=template&id=9efa6d12"
import script from "./PaginationUserEnrolComponent.vue?vue&type=script&lang=js"
export * from "./PaginationUserEnrolComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__